import {SectionItem} from 'common/components/items-menu/types';

export enum ActionType {
  Select,
  StageMenu,
  TriggerModal,
}

export enum MenuType {
  Tag,
  Tags,
}

export enum ModalType {
  CreateCustomEvent,
}

/* [ActionType.StageMenu] Items which result in staging a new menu */
export type StageMenuItem<T extends MenuType = MenuType> = {
  /** Defines the resulting action from the item */
  readonly action: ActionType.StageMenu;

  /** Defines the type of menu to render */
  readonly menuType: T;
};

export type StageTagMenuItem = StageMenuItem<MenuType.Tag> & {
  /** the number of matching items */
  count: number;

  /** The value of the item in context of the menu */
  value: string;
};

export type StageTagsListMenuItem = StageMenuItem<MenuType.Tags>;

/* [ActionType.TriggerModal] Items which result in a triggered modal */
export type TriggerModalItem<T extends ModalType = ModalType> = {
  /** The menu type to which the Item is opened */
  readonly action: ActionType.TriggerModal;

  /** Defines the type of modal to render */
  readonly modalType: T;
};

export type ItemTriggerCustomEventModal = TriggerModalItem<ModalType.CreateCustomEvent> & {
  /* The header of the presented modal */
  label: string;
};

/* [ActionType.Select] Items which result in an actual selection. To preserve historical integrations, this can also be undefined */
export type SelectItem = {
  /** The menu type to which the Item is opened */
  readonly action?: ActionType.Select;
};

export type EventItem = SelectItem & {
  /** The API value of the event */
  value: any;

  /** id of the custom event */
  id?: number;

  /** Specifies if the event is a custom event */
  custom?: boolean;

  /** Specifies if the event is a collect everything event */
  isCollectEverything?: boolean;

  /** The display name of the event */
  label: string;

  /** The renamed label for the event */
  renamed?: string;

  /** Specifies if this event item is in the recently viewed list */
  isRecentlyViewed?: boolean;

  /** An optional prefix to the event label */
  labelPrefix?: string;
};

export type EventSectionItem = SectionItem<EventItem, Obj>;

export type EventMenuItem = EventItem | StageTagMenuItem | StageTagsListMenuItem | ItemTriggerCustomEventModal;
export type StageableMenuItem = Extract<EventMenuItem, StageMenuItem>;
export type TriggerableMenuItem = Extract<EventMenuItem, TriggerModalItem>;

export const EVENT_PROPERTIES: Array<keyof EventItem> = [
  `id`,
  `custom`,
  `label`,
  `value`,
  `renamed`,
  `isCollectEverything`,
  `isRecentlyViewed`,
];

export interface EventsMenu {
  isContentSearchable(): boolean;
}
